var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title pf-medium"},[_vm._v("使用说明")]),_c('div',{staticClass:"main"},[_vm._v(_vm._s(_vm.useDesc || ''))])])}
var staticRenderFns = []

export { render, staticRenderFns }